<template>
  <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
    <div class="well form-group" style="background: #e5e9ec">

      <!-- title -->
      <div class="grid-title no-border borderTop">
        <h4 style="padding-left: 6px">
          {{ i18nValues["exportconsolidated"] || "Consolidated" }}
          &nbsp;<span aria-label="United States" title="United States">🇺🇸</span>
        </h4>
      </div>

      <div class="grid-body no-border borderBottom">
        <el-form v-loading="loading != 0">
          <!-- Export buttons -->
          <el-form-item>
            <div class="export-buttons-container">
              <el-button icon="fas fa-file-excel" size="small" class="btn-primary" @click="exportExcel">
                {{ i18nValues["consolidatedPlants"] || "Consolidated Plants" }}
              </el-button>
              <el-button icon="fas fa-file-excel" size="small" class="btn-primary" @click="exportExcelExportSilos">
                {{ i18nValues["consolidatedSilos"] || "Consolidated Silos" }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
import { get } from "vuex-pathify"; // eslint-disable-line no-unused-vars

export default {
  name: "Consolidated",
  computed: {
    loading: get("pallet/loading"),
    i18nValues: get("i18nStore/valuesRetrieved"),
    globalCampaign: get("globalCampaign"),
    globalFieldSite: get("globalFieldSite"),
    selectedLanguage: get("i18nStore/selectedLanguage"),
  },
  methods: {
    exportExcel() {
      const filter = {
        selectedLanguage: this.selectedLanguage,
        campaignId: this.globalCampaign ? this.globalCampaign.id : null,
      };

      this.$store.dispatch("pallet/exportExcelConsolidated", filter).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const campaignName = this.globalCampaign && (this.globalCampaign.name || this.globalCampaign.code || this.globalCampaign.id)
          ? (this.globalCampaign.name || this.globalCampaign.code || this.globalCampaign.id)
          : "Sin campaña";
        const dateStr = new Date().toISOString().split("T")[0];
        const desiredName = `Consolidado_USA_${campaignName}_${dateStr}.xlsx`;
        link.download = desiredName.replace(/\s+/g, "_");
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
    exportExcelExportSilos() {
      const filter = {
        selectedLanguage: this.selectedLanguage,
        fieldSiteId: this.globalFieldSite ? this.globalFieldSite.id : null,
      };

      this.$store.dispatch("silo/exportExcelExportSilos", filter).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        const dateStr = new Date().toISOString().split("T")[0];
        const desiredName = `Consolidado_USA_Silos_${dateStr}.xlsx`;
        link.download = desiredName.replace(/\s+/g, "_");
        link.click();
        URL.revokeObjectURL(link.href);
      });
    },
  },
};
</script>

<style scoped>
.export-buttons-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
}
</style>


